import { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { Typography } from 'antd';
import PopoverTip from '@components/common/PopoverTip';
import { credibilityList } from '@utils/constants';

const { Text } = Typography;

const credibilityBadgeBg = color => `color-mix(in srgb, ${color} 14%, var(--ant-color-bg-container))`;

const credibilityBadgeStyles = css`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 0 10px;
    border: 1px solid ${({ $color }) => $color};
    background-color: ${({ $color }) => credibilityBadgeBg($color)};
    border-radius: 10px;
    color: ${({ $color }) => $color};
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    white-space: nowrap;
`;

export const CredibilityBadge = styled.span`
    ${credibilityBadgeStyles};
    cursor: default;
`;

export const CredibilityBadgeLegend = styled.dt`
    ${credibilityBadgeStyles};
    font-weight: normal;
`;

export const CredibilityDl = styled.dl`
    margin: 0;
    display: grid;
    grid-template-columns: auto 1fr;
    column-gap: 12px;
    row-gap: 8px;
    align-items: baseline;
    min-width: 320px;
`;

export const CredibilityDesc = styled.dd`
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    color: var(--ant-color-text);
`;

const CredibilityDt = styled.dt`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 0 10px;
    border: 1px solid ${({ $active, $color }) => ($active ? $color : 'var(--ant-color-border-secondary)')};
    background-color: ${({ $active, $color }) => ($active ? credibilityBadgeBg($color) : 'var(--ant-color-fill-secondary)')};
    border-radius: 10px;
    color: ${({ $active, $color }) => ($active ? $color : 'var(--ant-color-text-tertiary)')};
    font-weight: normal;
    white-space: nowrap;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
`;

const CredibilityDd = styled.dd`
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    color: ${({ $active }) => ($active ? 'var(--ant-color-text)' : 'var(--ant-color-text-tertiary)')};
    font-weight: ${({ $active }) => ($active ? 'bold' : 'normal')};
`;

/**
 * 专家可信度标记：边框胶囊 + 悬浮说明（PopoverTip）
 * @param {string} [credibility] - credibilityList 中的 value
 */
export function ExpertCredibilityBadge({ credibility }) {
    const credibilityInfo = credibilityList.find(a => a.value === credibility);
    if (!credibilityInfo) {
        return <Text type="secondary">暂无</Text>;
    }

    return (
        <PopoverTip
            placement="bottomLeft"
            content={
                <CredibilityDl>
                    {credibilityList.map(item => (
                        <Fragment key={item.value}>
                            <CredibilityDt $color={item.color} $active={item.value === credibility}>
                                <i className={`bi ${item.icon}`}></i>
                                {item.label}
                            </CredibilityDt>
                            <CredibilityDd $active={item.value === credibility}>{item.tooltip}</CredibilityDd>
                        </Fragment>
                    ))}
                </CredibilityDl>
            }
        >
            <CredibilityBadge $color={credibilityInfo.color}>
                <i className={`bi ${credibilityInfo.icon}`}></i>
                {credibilityInfo.label}
            </CredibilityBadge>
        </PopoverTip>
    );
}

/** 筛选表单等场景：可信度图例说明（无当前选中高亮） */
export function CredibilityLegendContent() {
    return (
        <CredibilityDl>
            {credibilityList.map(item => (
                <Fragment key={item.value}>
                    <CredibilityBadgeLegend $color={item.color}>
                        <i className={`bi ${item.icon}`}></i>
                        {item.label}
                    </CredibilityBadgeLegend>
                    <CredibilityDesc>{item.tooltip}</CredibilityDesc>
                </Fragment>
            ))}
        </CredibilityDl>
    );
}
